import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import Video from './video';

import styles from '../styles/versioningPropertiesUpload.module.scss';

const VersioningPropertiesUpload = ({ value, options }) => {
  let media;

  const textElement = (
    <Typo color="secondary" variant="b01">
      {value?.name}
    </Typo>
  );

  switch (options.type) {
    case 'video':
      media = (
        <div className={styles.video} data-testid="versioning-properties-upload-video">
          <Video
            url={value}
            shouldNotFloat
            shouldHideMenu
            shouldHideCustomControls
            shouldNotAutoplay
            shouldNotEnroll
          />
        </div>
      );
      break;
    case 'image':
      media = (
        <img
          className={styles.image}
          alt={value.alt}
          src={value?.url?.w550 || value?.url?.w1100}
          data-testid="versioning-properties-upload-image"
        />
      );
      break;
    case 'file':
      if (value.url) {
        media = (
          <a
            data-testid="versioning-properties-upload-file"
            href={value.url}
            rel="noreferrer"
            target="_blank"
          >
            {textElement}
          </a>
        );
        break;
      }

      media = textElement;
      break;
    default:
      media = null;
  }

  return media;
};

VersioningPropertiesUpload.propTypes = {
  options: PropTypes.shape({
    type: PropTypes.string,
  }),
  value: PropTypes.oneOfType([
    PropTypes.shape({
      alt: PropTypes.string,
      url: PropTypes.oneOfType([
        PropTypes.shape({
          w550: PropTypes.string,
        }),
        PropTypes.string,
      ]),
    }),
    PropTypes.string,
  ]).isRequired,
};

export default React.memo(VersioningPropertiesUpload);
